<template>
  <div>
    <div>
      <nav-bar />
    </div>
    <br>
    <b-container fluid>
      <b-row>
        <b-col md="6" class="my-1">
          <b-form-group horizontal class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Ingrese No. Viaje" v-on:keyup="getTrackingEnter" />
              <b-input-group-append>
                <b-btn @click="getTracking()">Buscar</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1">
          <b-form-group horizontal class="mb-0">
            <b-form-select
              :options="pageOptions"
              v-model="perPage"
              class="col-sm-5"
              @change="setPerPage"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1">
          <b-pagination
            :total-rows="totalItems"
            :per-page="perPage"
            v-model="currentPage"
            class="mb-0"
            aria-controls="listItems"
          /> 
        
        </b-col>
      </b-row>

      <div class="containerTable">
        <table class="table">
          <caption/>
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">No. de Viaje</th>
              <th scope="col">Empresa de Transporte</th>
              <th scope="col">Placa</th>
              <th scope="col">Último Puesto de Control</th>
              <th scope="col">Fecha de Registro</th>
              <th scope="col">Observación</th>
              <th scope="col">Nombre de usuario</th>
              <th scope="col">Tipo Registro</th>
              <th scope="col">Foto</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td>
                <!-- Mostrar el id del viaje como un link para ver todo el historial-->
                <router-link
                  :to="{name:'resumenViaje', params:{id_tracking:item.Id, transport_company_name: item.TransportCompanyName}}"
                  tag="a"
                >{{item.Id}}</router-link>
              </td>
              <td>{{item.tripNumber}}</td>
              <td>{{item.TransportCompanyName}}</td>
              <td>{{item.licensePlate}}</td>
              <td>{{item.NamePointControl}}</td>
              <td>{{item.registrationDate}}</td>
              <td>{{item.remark}}</td>
              <td>{{item.userName}}</td>
              <td>{{item.activity}}</td>
              <td>
                {{item.imagePC}}
                <b-button
                  size="sm"
                  class="mr-1"
                  @click.stop="info(item, item.index, $event.target)"
                >ver</b-button>
              </td>
            </tr>
          </tbody>
        </table>
       
      </div>

      <!-- Info modal -->
      <b-modal id="modalInfo" :title="modalInfo.title" ok-only size="lg" @hide="resetModal" >
        <div>
          <b-carousel
            id="carousel1"
            v-model="slide"
            :interval="4000"
            style="text-shadow: 1px 1px 2px #333;"
            controls
            indicators
            background="#ababab"            
            img-width="600"
            img-height="600"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <b-carousel-slide v-for="(i, index) of img" :key="index">
              <img slot="img" :src="'data:image/jpeg;base64,'+i" width="600" height="600">
            </b-carousel-slide>
          </b-carousel>
        </div>
      </b-modal>
    </b-container>
    <b>Total:</b> <label> {{totalItems}}</label><br>
    <label v-if="loading"> Buscando... </label>
  </div>
</template>

<script>
// import moment from 'moment'
import navBar from "@/components/NavBar.vue";
export default {
  components: {
    navBar
  },
  data() {
    return {
      //items: items,
      items: [],
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      pageOptions: [10, 20, 30, 40],
      modalInfo: { title: "", content: "" },
      userInfo: {},
      slide: 0,
      sliding: null,
      img: {},
      filter: "",
      loading: false
    };
  },
  computed: {},
  methods: {
    filteredItems() {
      if (this.filter.length > 0) {
        this.items = this.items.filter(item => {
          return item.Id.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
        });
      } else {
        this.getTracking();
      }
    },
    info(item, index, button) {
      this.modalInfo.title = "Fotos del viaje";
      this.axios
        .get("PC/GetImagesLastTrackingFromS3Async", {
          params: {
            id_tracking: JSON.stringify(item.Id),
            company_name: item.TransportCompanyName
          }
        })
        .then(response => {
          this.img = response.data;
          this.modalInfo.content = "Acá van a ir las imágenes";
          this.$root.$emit("bv::show::modal", "modalInfo", button);
        });
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalItems = filteredItems.length;
      //this.currentPage = currentPage;
    },
    getTracking() {
      this.loading = true;
      this.axios
        .get("PC/GetGetLastTrackingPC", {
          params: {
            idCompanie: this.userInfo.idCompany,
            typeComapanie: this.userInfo.typeCompany,
            skip: this.currentPage,
            take: this.perPage,
            search: this.filter
          }
        })
        .then(response => {
          if(response.data != "" && response.data != null){
            this.totalItems = response.data.Total;
            this.items = response.data.data;
           
          } 
          this.loading = false;
        });
    },
    getTrackingEnter(e) {
      if (e.keyCode === 13) {
        this.getTracking();
      } 
      
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    endTravelPC(item) {
      let self = this;
      this.items = [];
      this.axios
        .get("PC/EndTravel", {
          params: {
            id_tracking: JSON.stringify(item.Id)
          }
        })
        .then(response => {
          if (response.data) {
            alert("Se ha finalizado el viaje correctamente");
            //Se llama el metodo que consulta la data
            self.getTracking();
          } else
            alert(
              "Error al finalizar el viaje, Intente Nuevamente o comuniquese con el administrador "
            );
        });
    },
    setPerPage() {
      this.getTracking();
    }
  },
  mounted() {
    // this.getTracking();
    console.log(this.$route.query.token)
    let uri = process.env.VUE_APP_URL_API+'/Authenticate/Login';
    this.axios.get(uri, {
          params: {
            token: this.$route.query.token
          }
        })
      .then(response => {
        if(response.data != null && response.data != ""){
          this.$session.start();
            //se almacena los datos de la sesion
            this.$session.set('login-storage', response.data)
            this.$router.push({ name: "resumen" });
        }
      })
      this.getTracking()
  },
  created() {
    if (this.$session.get("login-storage")) {
      this.userInfo = this.$session.get("login-storage");
    }
    this.totalItems = 0;
  },
  watch: {
    currentPage: {
      handler: function() {
        this.getTracking();
        //this.$refs.table.refresh();
      }
    }
  }
};
</script>
<style>
.containerTable {
  height: 90% !important;
  overflow-x: scroll;
}
table {
  width: 100%;
  background-color: white;
  text-align: center;
  border-collapse: collapse;
}
th,
td {
  border: 1px solid #dee2e6;
  padding: 0px;
}
thead {
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
  background-color: #ddd;
}
tr:nth-child(even) {
  background-color: #ddd;
}
</style>
